export const COLABORADOR = '73acd9a5972130b75066c82595a1fae3';
export const TOKEN = '94c8aa2452bccd82ee129b46f7c4be79';
export const True = 'f827cf462f62848df37c5e1e94a4da74';
export const False = 'f8320b26d30ab433c5a54546d21f414c';
